/** Import react/libraries section **/
import React, { useMemo } from 'react';

/** Import resources section **/
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

/** Import helpers section **/
import './AreasStyles.scss';

/** Import component section **/
import PageTitle from '../../components/PageTitle/PageTitleComponent';
import MUISelect from '../../components/inputs/MUISelect';
import FilterBy from '../../components/FilterBy/FilterBy';
import DataTable from '../../components/DataTable/DataTableComponent';
const AreaView = ({
  companies,
  selectedCompanyId,
  onCompanyChange,
  onFilterBy,
  loading,
  list,
  onAdd,
  onEdit,
  onDelete
}) => {
  const ActionsCell = ({ row }) => {
    return (
      <div className="g-actions-cell">
        <EditIcon className="g-row-action-button" onClick={() => onEdit(row)} />
        <Divider orientation="vertical" flexItem />
        <DeleteIcon
          className="g-row-action-button delete"
          onClick={() => onDelete(row)}
        />
      </div>
    );
  };

  const tableColumns = useMemo(
    () => [
      {
        name: 'id',
        selector: (row) => row?.id,
        sortable: true,
        center: true,
        omit: true
      },
      {
        name: 'Área',
        selector: (row) => row?.title,
        sortable: true,
        center: true
      },
      {
        name: 'Compañía',
        selector: (row) => row?.company?.name,
        sortable: true,
        center: true
      },
      {
        name: '',
        cell: (row) => <ActionsCell row={row} />,
        ignoreRowClick: true,
        grow: 0
      }
    ],
    []
  );

  return (
    <>
      <PageTitle title="Áreas" />
      <Paper className="g-page-header areas_header">
        <div className="areas_header_filters">
          <MUISelect
            label="Compañía"
            defaultValue={selectedCompanyId}
            items={companies}
            idSelector="id"
            selector="name"
            name="company"
            id="company"
            onChange={onCompanyChange}
          />
          <FilterBy onChange={onFilterBy} width={180} />
        </div>
        <Button onClick={onAdd} startIcon={<AddCircleIcon />}>
          Agregar nueva area
        </Button>
      </Paper>

      <DataTable data={list} columns={tableColumns} loading={loading} />
    </>
  );
};

export default AreaView;
